import BdcDispatch from "../components/Bdc/Dispatch";

const BdcDispatchPage = () => <BdcDispatch />;

export default BdcDispatchPage;
